import {db} from "@/firebase/init";

export default {
	namespaced: true,
	state: {
		alert: {
			type: null,
			message: null,
			show: false
		},
		diskUsageAlerts: {},
		queryListener: null
	},
	getters: {
		type(state) {
			return state.alert.type
		},
		message(state) {
			return state.alert.message
		},
		show(state) {
			return state.alert.show
		},
		queryListener(state){
			return state.queryListener;
		},
		showDiskAlert (state){
			return state.diskUsageAlerts.showAlert;
		},
		getAlertDetails (state) {
			return state.diskUsageAlerts
		}
	},
	mutations: {
		detailsMutate(state, payload) {
			if (payload.message.includes('insufficient permissions')) {
				state.alert.message = 'Session Expired. Please refresh the page to avoid any issues.'
			} else {
				state.alert.message = payload.message
			}
			state.alert.type = payload.type
			state.alert.show = payload.show
		},
		showMutate(state, payload) {
			state.alert.show = payload.show
		},
		updateSnapshotListener(state, payload){
			state.queryListener = payload;
		},
		updateDiskAlert(state, payload){
			state.diskUsageAlerts = payload;
		}
	},
	actions: {
		update(context, payload) {
			context.commit('detailsMutate', payload)
		},
		showUpdate(context, payload) {
			context.commit('showMutate', payload)
		},
		createRealTimeSnapShotOnHbMapping (context) {
			let UID = context.rootGetters.getUID;
			let query = db.collection('account-hb')
				.where('uid', '==', UID)
				.where('showAlert', '==', true);
			let queryListener = query.onSnapshot(querySnapshot => {
				querySnapshot.docChanges().forEach(changeDoc => {
					if (changeDoc.type === 'added'){
						context.commit('updateDiskAlert', changeDoc.doc.data());
					} else if(changeDoc.type === 'removed') {
						context.commit('updateDiskAlert', {});
					}
				})
			});
			context.commit('updateSnapshotListener', queryListener);
		}
	}
}
